export default __webpack_public_path__ + "static/media/updates.898fb791.svg";